import React from "react";
import {
  Thermometer, LayoutPanelTop, Grid3x3, Building2, Mountain, AudioLines, ArrowUpRight
} from "lucide-react";
import { SERVICES } from "../mock";

const ICONS = { Thermometer, LayoutPanelTop, Grid3x3, Building2, Mountain, AudioLines };

export default function Services() {
  return (
    <section id="services" className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <div className="text-xs font-bold uppercase tracking-[0.25em] text-yellow-700">What We Do</div>
            <h2 className="display section-underline mt-3 text-4xl md:text-5xl font-extrabold text-slate-900 uppercase">
              Our Core Services
            </h2>
          </div>
          <p className="max-w-md text-slate-600 leading-relaxed">
            Six specialised verticals, one accountable partner. Every scope is engineered, supplied and installed by our in-house teams.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-7">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon] || Building2;
            return (
              <article key={s.id} className="svc-card group bg-white rounded-xl overflow-hidden border border-slate-200">
                <div className="relative aspect-[16/10] overflow-hidden">
                  <img src={s.image} alt={s.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900/70 via-slate-900/20 to-transparent" />
                  <div className="absolute top-4 left-4 w-12 h-12 rounded-lg bg-yellow-700 grid place-items-center shadow-lg">
                    <Icon className="w-6 h-6 text-white" />
                  </div>
                  <div className="absolute bottom-4 left-4 text-white text-xs font-bold uppercase tracking-widest">
                    Service 0{i + 1}
                  </div>
                </div>
                <div className="p-7">
                  <h3 className="display text-2xl font-bold text-slate-900 group-hover:text-yellow-700 transition-colors">
                    {s.title}
                  </h3>
                  <p className="mt-2 text-slate-600 text-sm leading-relaxed">{s.desc}</p>
                  <ul className="mt-4 space-y-1.5">
                    {s.points.map((p) => (
                      <li key={p} className="text-sm text-slate-700 flex items-center gap-2">
                        <span className="w-1.5 h-1.5 bg-yellow-600 rounded-full" />
                        {p}
                      </li>
                    ))}
                  </ul>
                  <a href="#contact" className="mt-5 inline-flex items-center gap-1 text-sm font-bold text-yellow-800 hover:text-yellow-900">
                    Request a Quote <ArrowUpRight className="w-4 h-4" />
                  </a>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
